import { composeIO } from 'react-compose-io'
import { modalPriorizarIO } from './ModalPriorizar.IO'
import ModalPriorizarView from './ModalPriorizar.View'

export const ModalPriorizar = composeIO(ModalPriorizarView, modalPriorizarIO)
